//importing firebase
import {signOut} from "firebase/auth";
import {Auth} from "../../../firebase/firebase";

export function fb_signOut() {
  signOut(Auth)
    .catch(error => {
      console.error("Failed to sign out. ", error.message);
    })
}
